import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/features/redux-hooks";
import { PATH_NAME } from "../../configs/pathName";
import WhatsAppWidget from "../common/WhatsAppWidget/WhatsAppWidget";

const ProtectedLayout = () => {
  const basicUserInfo = useAppSelector((state) => state.authState.basicUserInfo);

  if (!basicUserInfo) {
    return <Navigate replace to={PATH_NAME.LOGIN} />;
  }

  return (
    <>
      <Outlet />
      <WhatsAppWidget/>

    </>
  );
};

export default ProtectedLayout;